import styled from "styled-components";

export const ReportDivWrapp = styled.div``;
export const ReportPageWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  margin: 20px auto;
  margin-bottom: 20px;
  box-shadow: 0 0 0.5cm rgb(0 0 0 / 50%);
  min-height: 15in;
  padding: 1.5cm !important;
  position: relative;
  text-align: left;
  max-width: 1140px;
`;

export const ReportTopSection = styled.div`
  margin-bottom: 20px;
`;

export const PageNumber = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.secondaryFont};
  font-weight: 400;
  float: right;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
`;

export const SieraLogo = styled.img`
  height: 40px;
  margin-bottom: 10px;
`;

export const DetailHeading = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.font1} !important;
  font-family: ${({ theme }) => theme.fontFamily.secondaryFont};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  span {
    display: block;
    font-size: ${({ theme }) => theme.fontSizes.font3} !important;
  }
`;

export const EmailHelpText = styled.p`
  font-family: ${({ theme }) => theme.fontFamily.primaryFont};
  margin: 0px;
  color: ${({ theme }) => theme.colors.grayL3 || "#676767"};
  font-weight: 600;
`;

export const Anchor = styled.a`
  color: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
`;

export const ReportName = styled.div`
  margin-top: 24px;
  font-size: 4rem !important;
  font-family: ${({ theme }) => theme.fontFamily.secondaryFont};
  font-weight: 400;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  span {
    display: block;
    font-size: ${({ theme }) => theme.fontSizes.font3} !important;
  }
`;

export const ReportDataSection = styled.div``;

export const ReprtHeaderTop = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.font3} !important;
  padding: 8px 16px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.grayL6 || "#F2F2F2"};
  font-family: ${({ theme }) => theme.fontFamily.secondaryFont};
  font-weight: 500;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
`;

export const ReportDataHeaderTop = styled.div`
  background-color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  font-size: ${({ theme }) => theme.fontSizes.font4} !important;
  padding: 8px 16px;
  font-family: ${({ theme }) => theme.fontFamily.primaryFont};
  color: ${({ theme }) => theme.colors.grayL4 || "#676767"};
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  overflow: hidden;
`;

export const ReportStatus = styled.div`
  float: right;
`;

export const PassReport = styled.div`
  background-color: ${({ theme }) => theme.colors.greenPrimary || "#11A70B"};
  color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  outline: none;
  border: none;
  border-radius: 5px;
  font-size: ${({ theme }) => theme.fontSizes.font7} !important;
  padding: 8px 32px;
  font-weight: bold;
`;

export const FailReport = styled.div`
  background-color: ${({ theme }) => theme.colors.redPrimary || "#DD0000"};
  color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  outline: none;
  border: none;
  border-radius: 5px;
  font-size: ${({ theme }) => theme.fontSizes.font7} !important;
  padding: 8px 32px;
  font-weight: bold;
`;

export const TimedoutReport = styled.div`
  background-color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  outline: none;
  border: none;
  border-radius: 5px;
  font-size: ${({ theme }) => theme.fontSizes.font7} !important;
  padding: 8px 32px;
  font-weight: bold;
`;

export const ReportCenterData = styled.div`
  background-color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  font-size: ${({ theme }) => theme.fontSizes.font4} !important;
  padding: 8px 16px;
  font-family: ${({ theme }) => theme.fontFamily.primaryFont};
  color: #707070;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  overflow: hidden;
  ${PassReport} {
    line-height: 30px;
    font-size: ${({ theme }) => theme.fontSizes.font5} !important;
  }
  ${FailReport} {
    line-height: 30px;
    font-size: ${({ theme }) => theme.fontSizes.font5} !important;
  }
`;
export const ReportRightSec = styled.div`
  float: right;
  line-height: 30px;
  font-size: ${({ theme }) => theme.fontSizes.font4} !important;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  font-weight: normal;
`;

export const VehicalDetailsData = styled.div``;

export const VehicleDatNA = styled.div`
  text-align: center;
  line-height: 50vh;
`;

export const ReportPageFooter = styled.div`
  position: absolute;
  bottom: 15px;
  left: 0;
  right: 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.grayL4 || "#9A9A9A"};
  font-family: ${({ theme }) => theme.fontFamily.secondaryFont};
  font-weight: 300;
`;

export const ReportCenterDataTable = styled.div`
  overflow: hidden;
  margin-top: 5px;
`;

export const ReportTableView = styled.div`
  margin: 10px 0px;
`;

export const ReportTableViewHeader = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.font3} !important;
  padding: 8px 16px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.grayL6 || "#F2F2F2"};
  font-family: ${({ theme }) => theme.fontFamily.secondaryFont};
  font-weight: 500;
`;

export const SectionData = styled.div``;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.fontSizes.font3} !important;
  padding: 8px 16px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.grayL6 || "#F2F2F2"};
  font-family: ${({ theme }) => theme.fontFamily.secondaryFont};
  font-weight: 500;
`;

export const SectionBody = styled.div``;

export const SectionName = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.font3} !important;
`;

export const SectionTotalTime = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.font4} !important;
`;

export const QuestionData = styled.div`
  display: flex;
  padding: 8px 16px;
`;

export const WarningSign = styled.div`
  flex: 1;
`;

export const QuestionBody = styled.div`
  flex: 18;
  font-size: ${({ theme }) => theme.fontSizes.font5} !important;
  font-family: ${({ theme }) => theme.fontFamily.primaryFont};
  align-items: center;
  display: block;
`;

export const QuestionResponse = styled.div`
  flex: 3;
  display: flex;
  justify-content: center;
  font-size: ${({ theme }) => theme.fontSizes.font5} !important;
  font-family: ${({ theme }) => theme.fontFamily.primaryFont};
  align-items: center;
  display: inline-flex;
`;

export const QuestionResponseTime = styled.div`
  flex: 3;
  display: flex;
  justify-content: right;
  font-size: ${({ theme }) => theme.fontSizes.font5} !important;
  font-family: ${({ theme }) => theme.fontFamily.primaryFont};
  align-items: center;
  display: inline-flex;
`;

export const ReportTableCenterSec = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  font-size: ${({ theme }) => theme.fontSizes.font4} !important;
  padding: 8px 16px;
  font-family: ${({ theme }) => theme.fontFamily.primaryFont};
  color: ${({ theme }) => theme.colors.grayL3 || "#676767"};
`;

export const ReportTableNameLeft = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.font5} !important;
  font-family: ${({ theme }) => theme.fontFamily.primaryFont};
  flex: 1;
  align-items: center;
  display: inline-flex;
`;
export const ReportTableNameCenter = styled.div`
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.font5} !important;
  font-family: ${({ theme }) => theme.fontFamily.primaryFont};
  flex: 1;
  align-items: center;
  display: grid;
`;
export const ReportTableNameRight = styled.div`
  display: block;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
`;

/* Incident Report Impact Severity Status Button */
export const ImpactSeverityLow = styled.div`
  background-color: #11a70b;
  color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  outline: none;
  border: none;
  border-radius: 5px;
  font-size: ${({ theme }) => theme.fontSizes.font7} !important;
  padding: 8px 32px;
  font-weight: bold;
`;
export const ImpactSeverityMedium = styled.div`
  background-color: ${({ theme }) => theme.colors.orangePrimary || "#DD9000"};
  color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  outline: none;
  border: none;
  border-radius: 5px;
  font-size: ${({ theme }) => theme.fontSizes.font7} !important;
  padding: 8px 32px;
  font-weight: bold;
`;
export const ImpactSeverityHigh = styled.div`
  background-color: ${({ theme }) => theme.colors.redPrimary || "#DD0000"};
  color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  outline: none;
  border: none;
  border-radius: 5px;
  font-size: ${({ theme }) => theme.fontSizes.font7} !important;
  padding: 8px 32px;
  font-weight: bold;
`;

export const PageMoreDetails = styled.div`
  margin-top: 10px;
  position: absolute;
  bottom: 60px;
  svg {
    width: 16px;
    display: inline;
  }
  p {
    display: inline;
    margin-left: 10px;
    margin-right: 10px;
    font-family: ${({ theme }) => theme.fontFamily.primaryFont};
    color: ${({ theme }) => theme.colors.grayL3 || "#676767"};
  }
`;

export const ReportCenterDataTableImg = styled.div`
  overflow: hidden;
  margin-top: 5px;
  img {
    width: 100%;
    height: fit-content;
  }
`;

export const UnauthorizedButton = styled.div`
  background-color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  outline: none;
  border: none;
  border-radius: 5px;
  font-size: ${({ theme }) => theme.fontSizes.font7} !important;
  padding: 8px 32px;
  font-weight: bold;
`;

export const PedestrianButtonStyle = styled.div`
  background-color: ${({ theme }) => theme.colors.redPrimary || "#DD0000"};
  color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  outline: none;
  border: none;
  border-radius: 5px;
  font-size: ${({ theme }) => theme.fontSizes.font7} !important;
  padding: 8px 32px;
  font-weight: bold;
`;

export const ObjectButtonStyle = styled.div`
  background-color: ${({ theme }) => theme.colors.orangePrimary || "#DD9000"};
  color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  outline: none;
  border: none;
  border-radius: 5px;
  font-size: ${({ theme }) => theme.fontSizes.font7} !important;
  padding: 8px 32px;
  font-weight: bold;
`;

export const PedestrianPositionButton = styled.div`
  text-transform: uppercase;
  background-color: ${({ theme }) => theme.colors.redPrimary || "#DD0000"};
  color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  outline: none;
  border: none;
  font-weight: bold;
  border-radius: 5px;
  font-size: ${({ theme }) => theme.fontSizes.font7} !important;
  padding: 5px 20px;
  display: inline-flex;
  margin-bottom: 10px;
  width: 180px;
  i {
    font-size: ${({ theme }) => theme.fontSizes.font6};
    margin-right: 10px;
  }
`;

export const ObjectPositionButton = styled.div`
  text-transform: uppercase;
  background-color: ${({ theme }) => theme.colors.orangePrimary || "#DD9000"};
  color: ${({ theme }) => theme.colors.grayL7 || "#FFFFFF"};
  outline: none;
  border: none;
  font-weight: bold;
  border-radius: 5px;
  font-size: ${({ theme }) => theme.fontSizes.font7} !important;
  padding: 5px 20px;
  display: inline-flex;
  margin-bottom: 10px;
  width: 180px;
  i {
    font-size: ${({ theme }) => theme.fontSizes.font6};
    margin-right: 10px;
  }
`;
export const ReportDetailsSection = styled.div``;

export const NotesStyledDiv = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.primaryFont};
  color: ${({ theme }) => theme.colors.redPrimary || "#DD0000"};
  display: block;
  padding: 0% 2%;
  font-size: ${({ theme }) => theme.fontSizes.font6} !important;
  word-wrap: break-word;
`;

export const QuestionDetails = styled.div`
  border-radius: 5px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
`;
